export enum TABS {
  DETAILS = 'details',
  BRANDING = 'emailBranding'
}
